import styled from "styled-components";

export const ModalWarnTextBox = styled.div`
  padding: 8px 12px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
`;
